<div class="container-main">
  <!-- <div class="new-btn back-button" [ngStyle]="{ 'visibility': !otpWithMobile ? 'visible' : 'hidden' }"> -->
  <div class="new-btn back-button" *ngIf="!otpWithMobile && !isOnePass">
    <button  mat-button (click)="goBack()">
      <mat-icon >navigate_before</mat-icon>
      Back
    </button>
  </div>
  <div class="new-btn back-button" *ngIf="otpWithMobile && !isOnePass">
    <button  mat-button (click)="goBackTourlpage()">
      <mat-icon >navigate_before</mat-icon>
      Back
    </button>
  </div>

  <div class="form-style">
    <mat-card class="padding-for-card">
      <h1 class="center-customer-information">Customer Information</h1>

      <!-- FORM FOR bName -->
      <form [formGroup]="otpForm" *ngIf="otpWithMobile">
        <div class="input-box">
          <mat-form-field appearance="outline">
            <input matInput #phoneInput type="tel" placeholder="Enter mobile number" formControlName="phone" />
          </mat-form-field>
          <mat-error *ngIf="otpForm.get('phone')?.dirty && otpForm.get('phone')?.invalid">
            Please provide a valid 10-digit mobile number (only numbers allowed).
          </mat-error>
        </div>
        <div class="new-btn">
          <button type="submit" (click)="sendOtp()" [disabled]="otpForm.invalid || isOtpCalled ">
            Send OTP
          </button>
        </div>
      </form>

      <!-- FORM FOR ONEPASS -->

      <form [formGroup]="transactionForm" *ngIf="!otpWithMobile">
        <div class="input-box">
          <mat-form-field appearance="outline">
            <input matInput type="text" placeholder="Enter first name" formControlName="firstname" maxlength="50" />
          </mat-form-field>
          <mat-error *ngIf="transactionForm.get('firstname')?.dirty && transactionForm.get('firstname')?.errors?.['required']">
            First name is required.
          </mat-error>
          <mat-error *ngIf="transactionForm.get('firstname')?.dirty && transactionForm.get('firstname')?.errors?.['pattern']">
            First name should contain only letters (no numbers or special characters).
          </mat-error>
        </div>

        <div class="input-box">
          <mat-form-field appearance="outline">
            <input matInput type="text" placeholder="Enter last name" formControlName="lastname" maxlength="50" />
          </mat-form-field>
          <mat-error *ngIf="transactionForm.get('lastname')?.dirty && transactionForm.get('lastname')?.errors?.['required']">
            Last name is required.
          </mat-error>
          <mat-error *ngIf="transactionForm.get('lastname')?.dirty && transactionForm.get('lastname')?.errors?.['pattern']">
            Last name should contain only letters (no numbers or special characters).
          </mat-error>
        </div>

        <div class="input-box">
          <mat-form-field appearance="outline">
            <input matInput placeholder="Enter email id" formControlName="email" />
          </mat-form-field>
          <mat-error *ngIf="
              transactionForm.get('email')?.touched &&
              transactionForm.get('email')?.invalid
            ">
            Email id is invalid.
          </mat-error>
        </div>
        <div class="input-box">
          <mat-form-field appearance="outline">
            <input matInput type="tel" placeholder="Enter phone number" formControlName="phone" maxlength="10" />
          </mat-form-field>
          
          <mat-error *ngIf="transactionForm.get('phone')?.dirty && transactionForm.get('phone')?.errors?.['required']">
            Phone number is required.
          </mat-error>
          
          <mat-error *ngIf="transactionForm.get('phone')?.dirty && transactionForm.get('phone')?.errors?.['pattern']">
            Please enter a valid 10-digit phone number (only numbers).
          </mat-error>
          
        </div>
        <div class="input-box">
          <mat-form-field appearance="outline">
            <input matInput type="tel" placeholder="Enter OTP" formControlName="otp" maxlength="6" />
          </mat-form-field>
          
          <mat-error *ngIf="transactionForm.get('otp')?.dirty && transactionForm.get('otp')?.errors?.['required']">
            OTP is required.
          </mat-error>
          
          <mat-error *ngIf="transactionForm.get('otp')?.dirty && transactionForm.get('otp')?.errors?.['pattern']">
            OTP must be exactly 6 digits and contain only numbers.
          </mat-error>
        </div>
        <div class="new-btn">
          <button type="submit" (click)="saveTransaction()" [disabled]="transactionForm.pristine || isOtpCalled">
            Submit
          </button>
        </div>
      </form>
    </mat-card>
  </div>
</div>

<!-- <div class="container-main">
  <div class="col-12 pt-3 pb-3 FormsMain d-flex justify-content-center align-items-center">
    <div class="rounded FormStyle" style="padding: 30px">
      <form class="rounded" [formGroup]="transactionForm">
        <div style="
            display: flex;
            flex-direction: row;
            gap: 10px;
            padding-bottom: 10px;
          ">
          <h1 class="m-0 text-primary">Customer Information</h1>
        </div>
        <div class="FormStyleVer">
          <div class="form-field-chng" *ngIf="sendOTP == true">
            <mat-form-field appearance="outline">
              <mat-label>First Name</mat-label>
              <input matInput placeholder="First Name" value="" formControlName="firstname" required />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Last Name</mat-label>
              <input matInput placeholder="Last Name" value="" formControlName="lastname" required />
            </mat-form-field>
          </div>


          <div [ngClass]="sendOTP ? 'form-field-chng' : 'no-gap'">
            <mat-form-field appearance="outline" *ngIf="sendOTP == true">
              <mat-label>Email Id</mat-label>
              <input matInput placeholder="Ex. abc@xyz.com" formControlName="email" value="" required />
            </mat-form-field>
            <div [ngStyle]=" sendOTP ? { display: 'flex', 'flex-direction': 'column' } : {}">
              <mat-form-field class="no-padding" appearance="outline">
                <mat-label>Mobile No.</mat-label>
                <input matInput type="text" placeholder="Ex. 999-999-9999" formControlName="phone" required />
              </mat-form-field>
              <mat-error
                *ngIf=" transactionForm.get('phone')?.hasError('pattern') && transactionForm.get('phone')?.touched">
                Please enter exactly 10 digits
              </mat-error>
              <mat-error
                *ngIf=" transactionForm.get('phone')?.touched && transactionForm.get('phone')?.invalid && transactionForm.get('phone')?.touched ">
                Mobile number is required
              </mat-error>
            </div>
          </div>


          <div class="form-field-chng" *ngIf="sendOTP == true">
            <mat-form-field appearance="outline">
              <mat-label>OTP</mat-label>
              <input matInput placeholder="OTP" formControlName="otp" required />
            </mat-form-field>

            <span *ngIf=" transactionForm.get('otp')?.hasError('pattern') && transactionForm.get('otp')?.touched
              " style="
                color: red;
                padding-right: 15px;
                font-size: 12px;
                padding-left: 15px;
              ">Please enter exactly 6 digits</span>
          </div>
        </div>

        <div style="
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            padding: 10px 19px;
          " [ngStyle]=" sendOTP ? { padding: '0px 0px' } : { padding: '10px 19px' }">
          <button class="btn btn-primary" (click)="goBack()" [hidden]="!sendOTP">
            Back
          </button>
          <button type="submit" class="btn btn-primary" [disabled]="transactionForm.invalid"
            (click)="sendOTP ? onSubmission() : sendOtpData(sendOTP)">
            {{ sendOTP ? "Submit" : "Send OTP" }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div> -->

<!-- 
<div class="container-main">
  <div>
    <div class="FormStyle">
      <mat-card class="padding-for-card">
        <form [formGroup]="transactionForm">
          <h1 class="center-customer-information">Customer Information</h1>
          <div>
            <div class="form-field-chng" *ngIf="showFormWithOutOtpScreen  || sendOTP">
              <div class="margin-after-one-field">
                <mat-form-field appearance="outline" class="width-input-field">
                  <input matInput type="text" formControlName="firstname" placeholder="First Name" required />
                </mat-form-field>
                <div
                  *ngIf="transactionForm.get('firstname')?.touched && transactionForm.get('firstname')?.touched && transactionForm.get('phone')?.invalid"
                  class="red-color-text">
                  *Please enter first name.
                </div>

              </div>
              <div class="margin-after-one-field">
                <mat-form-field appearance="outline" class="width-input-field">
                  <input matInput type="text" formControlName="lastname" placeholder="Last Name" required />
                </mat-form-field>
                <div
                  *ngIf="transactionForm.get('lastname')?.touched && transactionForm.get('lastname')?.touched && transactionForm.get('phone')?.invalid"
                  class="red-color-text">
                  *Please enter last name.
                </div>
              </div>
            </div>

            <div>
              <div [ngClass]="sendOTP ? 'form-field-chng' : 'no-gap'">
                <div class="margin-after-one-field">
                  <div *ngIf="showFormWithOutOtpScreen  || sendOTP">
                    <mat-form-field appearance="outline" class="width-input-field">
                      <input matInput placeholder="Email Id" formControlName="email" value="" />
                    </mat-form-field>
                    <div
                      *ngIf="transactionForm.get('email')?.touched && transactionForm.get('email')?.touched && transactionForm.get('phone')?.invalid"
                      class="red-color-text">
                      *Please enter email id.
                    </div>
                  </div>
                </div>

                <div [ngStyle]="sendOTP ? { display: 'flex', 'flex-direction': 'column' } : {}">
                  <mat-form-field class="no-padding" appearance="outline" class="width-input-field">
                    <input matInput type="text" placeholder="Ex. 999-999-9999" formControlName="phone" />
                  </mat-form-field>
                  <mat-error
                    *ngIf="transactionForm.get('phone')?.hasError('pattern') && transactionForm.get('phone')?.touched">
                    Please enter exactly 10 digits.
                  </mat-error>
                  <mat-error
                    *ngIf=" transactionForm.get('phone')?.touched && transactionForm.get('phone')?.invalid && transactionForm.get('phone')?.touched ">
                    Mobile number is required.
                  </mat-error>
                </div>
              </div>
            </div>

            <div>
              <div class="form-field-chng" *ngIf="sendOTP == true">
                <mat-form-field appearance="outline" class="width-input-field">
                  <input matInput placeholder="OTP" formControlName="otp" />
                </mat-form-field>
                <span *ngIf=" transactionForm.get('otp')?.hasError('pattern') && transactionForm.get('otp')?.touched
                     " style=" color: red; padding-right: 15px;font-size: 12px; padding-left: 15px; ">Please enter
                  exactly 6
                  digits</span>
              </div>
            </div>
          </div>

          <div style="display: flex; flex-direction: row; justify-content: space-between;"
            *ngIf="showFormWithOutOtpScreen">
            <button type="submit" class="btn btn-primary color-send width-input-field margin-forotp"
              (click)="onSubmission()">
              Submit
            </button>
          </div>

          <div style="display: flex; flex-direction: row; justify-content: space-between;"
            *ngIf="!showFormWithOutOtpScreen">
            <button type="submit" class="btn btn-primary color-send width-input-field margin-forotp"
              (click)="sendOTP ? onSubmission() : sendOtpData(true)">
              {{ sendOTP ? "Submit" : "Send OTP" }}
            </button>
          </div>
        </form>
      </mat-card>
    </div>
  </div>
</div> -->






















<!-- <div class="container-main">
  <div class="new-btn back-button" *ngIf="!otpWithMobile && !isOnePass">
    <button mat-button (click)="goBack()">
      <mat-icon class="mb-1">navigate_before</mat-icon>
      Back
    </button>
  </div>
  <div class="form-style">
    <mat-card class="padding-for-card">
      <h1 class="center-customer-information">Customer Information</h1>

      <form [formGroup]="otpForm" *ngIf="otpWithMobile">
        <div class="input-box">
          <mat-form-field appearance="outline">
            <input matInput  type="tel"  placeholder="Enter mobile number" formControlName="phone" />
          </mat-form-field>
          <mat-error *ngIf="
              otpForm.get('phone')?.touched && otpForm.get('phone')?.invalid
            ">
            Please provide a valid 10-digit mobile number
          </mat-error>
        </div>
        <div class="new-btn">
          <button type="submit" (click)="sendOtp()" [disabled]="otpForm.invalid">
            Send OTP
          </button>
        </div>
      </form>


      <form [formGroup]="transactionForm" *ngIf="!otpWithMobile">
        <div class="input-box">
          <mat-form-field appearance="outline">
            <input matInput type="text" placeholder="Enter first name" formControlName="firstname" />
          </mat-form-field>
          <mat-error *ngIf="
              transactionForm.get('firstname')?.touched &&
              transactionForm.get('firstname')?.invalid
            ">
            First name is required.
          </mat-error>
        </div>
        <div class="input-box">
          <mat-form-field appearance="outline">
            <input matInput type="text" placeholder="Enter last name" formControlName="lastname" />
          </mat-form-field>
          <mat-error *ngIf="
              transactionForm.get('lastname')?.touched &&
              transactionForm.get('lastname')?.invalid
            ">
            Last name is required.
          </mat-error>
        </div>
        <div class="input-box">
          <mat-form-field appearance="outline">
            <input matInput placeholder="Enter email id" formControlName="email" />
          </mat-form-field>
          <mat-error *ngIf="
              transactionForm.get('email')?.touched &&
              transactionForm.get('email')?.invalid
            ">
            Email id is invalid.
          </mat-error>
        </div>
        <div class="input-box">
          <mat-form-field appearance="outline">
            <input matInput type="number" placeholder="Enter phone number" formControlName="phone" />
          </mat-form-field>
          <mat-error *ngIf="
              transactionForm.get('phone')?.touched &&
              transactionForm.get('phone')?.invalid
            ">
            Phone number is required.
          </mat-error>
        </div>
        <div class="input-box">
          <mat-form-field appearance="outline">
            <input matInput placeholder="Enter OTP" formControlName="otp" />
          </mat-form-field>
          <mat-error *ngIf="
              transactionForm.get('otp')?.touched &&
              transactionForm.get('otp')?.invalid
            ">
            OTP is required.
          </mat-error>
        </div>
        <div class="new-btn">
          <button type="submit" (click)="saveTransaction()" [disabled]="transactionForm.pristine">
            Submit
          </button>
        </div>
      </form>
    </mat-card>
  </div>
</div> -->